import { useTranslation } from 'react-i18next'
import { displayRate, fmt, type Trade } from '../api'

/**
 * Recent fills, newest first. A fill is coloured against the one before it —
 * the familiar up/down tick — since the chain records no aggressor side.
 */
export default function TradeTape({ trades, base, quote }: { trades: Trade[]; base: string; quote: string }) {
  const { t } = useTranslation()
  const rows = trades.map(x => ({ ...x, rate: displayRate(x.price, 'sell') }))

  return (
    <div className="panel">
      <div className="panel-head">
        <span className="grow">{t('trades')}</span>
        <span className="chip">{base}/{quote}</span>
      </div>
      <div className="panel-body flush">
        {rows.length === 0 ? (
          <div className="empty">{t('noData')}</div>
        ) : (
          <div className="tape">
            <div className="tape-head">
              <span>{t('price')}</span>
              <span className="right">{t('qty')}</span>
              <span className="right">{t('maker')}</span>
              <span className="right">{t('time')}</span>
            </div>
            {rows.map((x, i) => {
              const prev = rows[i + 1]?.rate
              const up = prev === undefined || x.rate >= prev
              return (
                <div className="tape-row" key={`${x.txid}-${i}`}>
                  <span className={`num ${up ? 'up' : 'down'}`}>{fmt(x.rate)}</span>
                  <span className="num right">{fmt(x.qty, 4)}</span>
                  <span className="muted right nowrap" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {x.maker_account}
                  </span>
                  <span className="muted right num">
                    {new Date(x.occurred_at).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                  </span>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}
